import { useEffect, useRef } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";

const ProjectSelect = ({
  projectOptions = [],
  projectState = [],
  setProjectState,
  disabled = false,
  dashboardData = {},
  minWidth = "",
}) => {
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (
      isFirstLoad.current &&
      (dashboardData?.project || dashboardData?.default_projects)
    ) {
      if (dashboardData?.project && dashboardData.project.length) {
        setProjectState(dashboardData.project);
      } else if (
        dashboardData?.default_projects &&
        dashboardData.default_projects.length
      ) {
        setProjectState(dashboardData.default_projects);
      }
      isFirstLoad.current = false;
    }
    // eslint-disable-next-line
  }, [dashboardData.project, dashboardData.default_projects, setProjectState]);

  const isAllSelected =
    projectOptions.length > 0 && projectState.length === projectOptions.length;

  const handleChange = (event) => {
    const value = event.target.value;
    if (value.includes("ALL")) {
      setProjectState(isAllSelected ? [] : projectOptions);
    } else {
      setProjectState(value);
    }
  };

  const renderSelected = (selected) => {
    if (selected.length <= 2) return selected.join(", ");
    return `${selected.slice(0, 2).join(", ")}, ...`;
  };

  return (
    <FormControl sx={{ minWidth: minWidth }} size="small" disabled={disabled}>
      <InputLabel id="project-select-label">Project</InputLabel>
      <Select
        labelId="project-select-label"
        multiple
        value={projectState}
        onChange={handleChange}
        input={<OutlinedInput label="Select Project(s)" />}
        renderValue={renderSelected}
      >
        <MenuItem value="ALL">
          <Checkbox
            checked={isAllSelected}
            indeterminate={projectState.length > 0 && !isAllSelected}
          />
          <ListItemText primary="Select All" />
        </MenuItem>
        {projectOptions.map((option) => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={projectState.indexOf(option) > -1} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ProjectSelect;
